import moment from "moment";

function getNormalDate(isoDateString) {
    if(!isoDateString) return "";
    return moment(isoDateString).format('DD-MM-YYYY HH:mm');
}

export default getNormalDate;